import React, { useEffect } from 'react'
import { WIDGET_SCRIPT_PATH } from '../utils/shared/constants';
import { USE_EMULATORS } from '../utils/config';

interface Props {
    previewRenderCounter: number
    campaignId: string
    labelNps: string
    labelComment: string
    labelThankYou: string
    labelSubmit: string
    logoUrl?: string
}

const PREVIEW_CLASS_NAME_PREFIX = 'preview-target_';
function Preview(props: Props) {
    useEffect(() => {
        console.log('Preview script changes', props.campaignId, props.labelNps)

        const previewClassName = PREVIEW_CLASS_NAME_PREFIX + props.campaignId;
        const divRefs = document.getElementsByClassName(previewClassName);
        if (!divRefs || divRefs.length === 0) {
            return;
        }
        const divRef = divRefs[0];

        const script = document.createElement('script');
        script.async = true;
        script.src = WIDGET_SCRIPT_PATH
        script.dataset.useEmulators = USE_EMULATORS + '';
        script.dataset.previewTargetClass = previewClassName;
        script.dataset.previewNpsLabel = props.labelNps;
        script.dataset.previewCommentLabel = props.labelComment;
        script.dataset.previewThankYouLabel = props.labelThankYou;
        script.dataset.previewSubmitLabel = props.labelSubmit;
        script.dataset.previewLogoUrl = props.logoUrl || '';

        divRef.innerHTML = '';
        console.log('Appending script', script, 'to div', divRef);
        divRef.append(script);
        console.log('Script appended');

        return () => {
            divRef.innerHTML = '';
        }

    }, [props.campaignId, props.labelNps, props.labelComment, props.labelSubmit, props.labelThankYou, props.previewRenderCounter])

    return <div
        className={`${PREVIEW_CLASS_NAME_PREFIX + props.campaignId} position-relative`}
        style={{ fontSize: '0.8rem' }}
    >
    </div>
}

export default Preview
